import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4d4e5a8c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "main-container"
};
import { onMounted, computed } from "vue";
import { useStore } from "vuex";
export default {
  __name: 'index',
  setup(__props) {
    const store = useStore();
    const taskVisible = computed(() => store.state.home.taskVisible || false);
    const orgInfo = computed(() => store.state.home.orgInfo || {});
    const collapsed = computed(() => store.state.home.collapsed || false);
    onMounted(() => {
      store.dispatch("initDictionaries");
      store.dispatch("home/getOrgInfo");
    });
    return (_ctx, _cache) => {
      const _component_NavContainer = _resolveComponent("NavContainer");
      const _component_TopContainer = _resolveComponent("TopContainer");
      const _component_RouterView = _resolveComponent("RouterView");
      const _component_FileImportTask = _resolveComponent("FileImportTask");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
        class: "common-layout",
        style: _normalizeStyle({
          paddingLeft: collapsed.value ? '90px' : '181px'
        })
      }, [_createVNode(_component_NavContainer, {
        orgInfo: orgInfo.value
      }, null, 8, ["orgInfo"]), _createElementVNode("div", _hoisted_1, [_createVNode(_component_TopContainer, {
        orgInfo: orgInfo.value
      }, null, 8, ["orgInfo"]), _createVNode(_component_RouterView)])], 4), _createVNode(_component_FileImportTask, {
        visible: taskVisible.value,
        "onUpdate:visible": _cache[0] || (_cache[0] = $event => taskVisible.value = $event)
      }, null, 8, ["visible"])], 64);
    };
  }
};